import { Component, OnInit, Input, NgZone, ViewChild, Output, EventEmitter } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { ProgramDto, ProgramDeliveryInformationDto, ProgramShippingLocationDto, ProgramId, ShippingLocationDto } from 'app/client-core/dtos/programs.model';
import { ValidationMessage } from 'app/validation';
import { ProgramService } from 'app/client-core/services/program.service';
import { ApiResponse } from 'app/client-core/api-response-models';
import * as moment from 'moment'
import { Observable, Subscription } from 'rxjs';
import { Tactic } from 'app/client-core/dtos/shipping-distribution.model';
import { ApiService } from 'app/client-core/api.service';
import { DropzoneComponent } from 'ngx-dropzone-wrapper';
import { BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { AddressListModalComponent } from '../components/address-list/address-list.modal.component';
import { AddressEditModalComponent } from '../components/address-edit/address-edit.modal.component';

@Component({
  selector: 'app-delivery-information',
  templateUrl: './delivery-information.component.html',
  styleUrls: ['./delivery-information.component.scss']
})
export class DeliveryInformationComponent implements OnInit {
  @ViewChild(DropzoneComponent) drpzone: DropzoneComponent;
  @Input() selectedProgramId: number;
  @Input() ready: boolean;
  @Output() onSelectAllClicked = new EventEmitter();
  programDto: ProgramDto = new ProgramDto();
  validationMessages: ValidationMessage;
  programDeliveryInformationResponse: ApiResponse<ProgramDeliveryInformationDto>;
  programDeliveryInformationDto: ProgramDeliveryInformationDto = new ProgramDeliveryInformationDto();
  oldProgramDeliveryInformationDto: ProgramDeliveryInformationDto = new ProgramDeliveryInformationDto();
  @Input() canEdit: boolean;
  submitting: boolean;
  validated: boolean;
  @Input() changeReason: number;
  @Input() onlyHaveDownloadMethods: boolean;
  minDate: Date = moment()
    .add("days", 1)
    .toDate();
  itemObjectsLeft: ProgramShippingLocationDto[] = [];
  itemObjectsRight: ProgramShippingLocationDto[] = [];
  addressFilter: string;
  distributionDto: any;
  submitted: boolean;
  @Input() type: string;
  @Input() fromCampaigns = false;
  config;
  file: any;
  shippingLocationDto: ShippingLocationDto = {} as ShippingLocationDto;
  isValid: boolean = false;
  submited: boolean;
  @Input() shouldValidateDate: boolean;

  @Input() contactType: string;
  @Input() selectedRetailerId: number;
  @Input() shouldValidate: boolean;
  @Input() showSelectAll: boolean;
  accountLocationId: any;
  createPlanModal: any;
  saving: boolean;
  shippingLocationSelectionUpdatedSubscription: Subscription;
  @Input() disableAddressSelection: boolean;
  searchTerm: string;

  onAfterValidate(isValid: boolean): void {
    console.log('>>IsValid', isValid);
    this.submited = true;
    if (!isValid)
      return;

    this.onSubmitShipping();
  }

  validatorOptions = {
    //container: '#messages',
    message: "Field is invalid",
    feedbackIcons: {
      valid: 'fa fa-check',
      invalid: 'fa fa-times',
      validating: 'fa fa-refresh'
    },
    fields: {
      city: {
        validators: {
          notEmpty: {
            message: "City is required"
          }
        }
      },
      address1: {
        validators: {
          notEmpty: {
            message: "Address1 is required"
          }
        }
      },
      zip: {
        validators: {
          notEmpty: {
            message: "Zip is required"
          }
        }
      }
    }
  };

  constructor(
    private layoutService: LayoutService,
    private programService: ProgramService,
    private zone: NgZone,
    private apiService: ApiService,
    private router: Router,
    private modalService: BsModalService
  ) {
    const self = this;
    this.config = {
      autoProcessQueue: false,
      acceptedFiles: '.csv',
      uploadMultiple: false,
      maxFiles: 1,
      dictDefaultMessage: 'Click or drop files here',
      init: function () {
        this.on('addedfile', function (file) {
          self.zone.run(() => {
            console.log(file);
            self.file = file;
            self.processUpload();
          });
        });
      }
    };
  }

  ngOnInit() {
    this.loadDeliveryLocationLookup();
    this.shippingLocationSelectionUpdatedSubscription = this.programService.shippingLocationSelectionUpdated.subscribe(data => {
      data.forEach(location => {
        this.unSelectAddress(location);
      });
    });

    
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.selectedProgramId = null;
      this.ready = false;
      this.itemObjectsLeft = [];
      this.itemObjectsRight = [];
      this.programDto = new ProgramDto();
      this.programDeliveryInformationDto = new ProgramDeliveryInformationDto();
      this.minDate = moment().add('days', 1).toDate();
      this.shippingLocationDto = new ShippingLocationDto();
      this.distributionDto = {};
      this.changeReason = 0;
      resolve(true);
    })
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  processUpload(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.apiService.uploadShippingLocations(
        this.file,
        this.selectedProgramId,
        this.programDeliveryInformationDto.deliveryDate ? this.programDeliveryInformationDto.deliveryDate.toISOString() : null,
        this.programDeliveryInformationDto.deliveryNotes
      ).subscribe(data => {
        const response = (data as any)
        try {
          if (!response.body.hasError) {
            this.drpzone.directiveRef.dropzone().removeAllFiles();
            if (!this.fromCampaigns) {
              this.validationMessages = new ValidationMessage(null, true, 'Upload Complete', 'success', 10);
              this.programService.addressAdded.next(new ProgramId(this.selectedProgramId));
              this.loadProgram();
            } else {
              resolve()
            }
          } else {
            this.drpzone.directiveRef.dropzone().removeAllFiles();
            // tslint:disable-next-line:max-line-length
            let errorString = 'One or more entries where unable to be imported due to data provided in the following fields <br>';
            errorString += response.body.errorMessage;
            errorString = errorString.replace(/\n/g, '<br>')
            this.validationMessages = new ValidationMessage(null, true, errorString, errorString, 30).isDanger();
            resolve();
          }
        } catch (error) {
          this.drpzone.directiveRef.dropzone().removeAllFiles();
          resolve();
        }
      }, error => {
        resolve();
      });
    })
  }

  init() {
    this.loadProgram();
  }

  closeModal() {
    this.layoutService.hideSideModal.next();
  }

  loadProgram(): void {
    console.log('>>loadProgram', this.selectedProgramId);

    if (!this.selectedProgramId) {
      this.ready = true;
      return;
    }

    this.programService.getProgram(this.selectedProgramId)
      .subscribe(res => {
        if (!res.hasError) {
          this.programDto = ProgramDto.fixDates(res.data);
          this.loadProgramDeliveryInformation();
          this.loadDeliveryLocationLookup();
          this.getDistribution();
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Program could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
        });
  }

  loadProgramDeliveryInformation(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.selectedProgramId) {
        this.ready = true;
        resolve(true);
        return;
      }

      this.programService.getProgramDeliveryInformation(this.selectedProgramId).subscribe(
        res => {
          if (!res.hasError) {
            this.programDeliveryInformationResponse = res;
            this.programDeliveryInformationDto = ProgramDeliveryInformationDto.fixDates(
              res.data
            );
            if (this.programDeliveryInformationDto.programShippingLocation) {
              this.itemObjectsRight = this.programDeliveryInformationDto.programShippingLocation;
            }

            // tslint:disable-next-line:max-line-length
            Object.assign(this.oldProgramDeliveryInformationDto || {}, {}, this.oldProgramDeliveryInformationDto || {});
            this.ready = true;
            resolve(true);
          } else {
            this.validationMessages = new ValidationMessage(
              res.error,
              true,
              "Program delivery information could not be retrieved"
            );
            resolve(false);
          }
        },
        (err: any) => {
          this.validationMessages = new ValidationMessage(
            null,
            true,
            "Unexpected error occured"
          );
          reject(err)
        },
        () => { }
      );
    });
  }

  shouldSaveInfo() {
    if (this.programDeliveryInformationDto.deliveryDate != this.oldProgramDeliveryInformationDto.deliveryDate) {
      return true;
    }

    if (this.programDeliveryInformationDto.deliveryNotes != this.oldProgramDeliveryInformationDto.deliveryNotes) {
      return true;
    }
    return false;
  }

  saveDeliveryInformation(programId?) {
    return new Promise((resolve, reject) => {
      this.submitting = true;
      this.validated = false;

      this.submitted = false;
      if (!this.isFutureDate() && this.shouldValidate) {
        this.submitted = true;
        this.validationMessages = new ValidationMessage(null, true, "there are some validation errors.");
        resolve(false);
        return;
      }

      this.programDeliveryInformationDto.programShippingLocation = this.itemObjectsRight.map(item => {
        return {
          ...item,
          programId: programId || this.selectedProgramId
        }
      });

      if (!this.validateFields() && !this.onlyHaveDownloadMethods && this.shouldValidate) {
        this.validated = true;
        this.submitting = false;
        resolve(false);
        return false;
      }

      let observe: Observable<ApiResponse<number>>;
      if (!this.programDeliveryInformationResponse) {
        this.programDeliveryInformationResponse = new ApiResponse<ProgramDeliveryInformationDto>();
      }
      this.programDeliveryInformationResponse.data = this.programDeliveryInformationDto;
      if (!this.programDeliveryInformationResponse.data.deliveryDate) {
        this.programDeliveryInformationResponse.data.deliveryDate = moment().add(1, 'days').toDate();
      }
      if (!this.programDeliveryInformationResponse.data.programShippingLocation || this.programDeliveryInformationResponse.data.programShippingLocation.length == 0) {
        this.programDeliveryInformationResponse.data.programShippingLocation = this.itemObjectsRight.map(it => {
          return {
            deliveryLocationId: it.deliveryLocationId,
            id: it.id,
            location: it.location,
            programId: programId || this.selectedProgramId,
            markedForDeletion: false,
            selected: true,
            showEdit: it.showEdit,
            contactName: it.contactName,
            address: it.address,
            distributed: false,
            unitNumber: it.unitNumber,
            emailOptIn: it.emailOptIn
          }
        })
      }
      if (!this.programDeliveryInformationResponse.data.id) {
        this.programDeliveryInformationResponse.data.id = programId || this.selectedProgramId;
      }
      observe = this.programService.saveDeliveryInformation(
        programId || this.selectedProgramId,
        this.programDeliveryInformationResponse
      );
      observe.subscribe(
        res => {
          if (!res.hasError) {
            let msg: string = "Delivery Information Saved";
            this.validationMessages = new ValidationMessage(
              null,
              true,
              msg
            ).isSuccess();
            this.getDistribution();
            this.programService.deliveryLocationSaved.next();
            this.closeModal();
            resolve(true);
          } else {
            this.validationMessages = new ValidationMessage(
              res.error,
              true,
              "Delivery Information could not be saved"
            );
            resolve(false);
          }
          this.submitting = false;
        },
        (err: any) => {
          this.submitting = false;
          this.validationMessages = new ValidationMessage(
            null,
            true,
            "Unexpected error occured"
          );
          resolve(false)
        },
        () => {
          this.submitting = false;
        }
      );
    });
  }

  isDeliveryAddressValid() {
    if (!this.programDeliveryInformationDto.programShippingLocation) {
      return false;
    }

    const validAddresses = this.programDeliveryInformationDto.programShippingLocation.filter(
      a => !a.markedForDeletion
    ).length;
    return validAddresses > 0;
  }

  showDeliveryAddressErroMessages() {
    return !this.isDeliveryAddressValid() && this.validated;
  }

  canSaveDeliveryInformation() {
    return this.isDeliveryAddressValid() && this.isDeliveryDateValid();
  }

  isDeliveryDateValid() {
    return (
      this.programDeliveryInformationDto.deliveryDate != null &&
      this.isFutureDate()
    );
  }

  isFutureDate() {
    if (!this.canEdit || this.fromCampaigns) {
      return true;
    }
    if (this.onlyHaveDownloadMethods) {
      return true;
    }
    if (
      !this.programDeliveryInformationDto ||
      !this.programDeliveryInformationDto.deliveryDate
    ) {
      return false;
    }

    const minDate = moment(this.minDate.toISOString());
    const choosedDate = moment(
      this.programDeliveryInformationDto.deliveryDate.toISOString()
    );
    return moment(choosedDate.format("MM/DD/YYYY")).isSameOrAfter(
      minDate.format("MM/DD/YYYY")
    );
  }

  validateFields(): boolean {
    if (this.shouldValidate && ((!this.isDeliveryAddressValid() || !this.isDeliveryDateValid()) && !this.onlyHaveDownloadMethods)) {
      this.validationMessages = new ValidationMessage(
        null,
        true,
        "Delivery Information could not be saved"
      );
      return false;
    }
    return true;
  }

  onRetailersTypeaheadSelected(selection) {
    this.programService.saveRetailer(this.selectedProgramId, selection.item.retailerId).subscribe(() => {
      this.init();
    });
  }

  loadDeliveryLocationLookup(
    selectedProgramId?,
    contactType?,
    selectedRetailerId?,
    accountLocationId?,
    contactTypeSecondaryType?,
    openSearch?,
    suppressEmailContact?,
    generateEmailReadyCopy?,
    dropdownSearch?,
    selectAll: number = 0,
    extraParams = {}
  ): void {
    this.programService.getDeliveryLocationLookup(
      (selectedProgramId || this.selectedProgramId) || null,
      (contactType || this.contactType) || null,
      (selectedRetailerId || this.selectedRetailerId) || null,
      (accountLocationId || this.accountLocationId) || null,
      contactTypeSecondaryType || null,
      openSearch || null,
      suppressEmailContact || null,
      generateEmailReadyCopy || null,
      dropdownSearch || null,
      selectAll,
      extraParams
    ).subscribe(
      res => {
        if (!res.hasError && res.data) {
          let data = (res.data.items || []).map((value, index, source) => {
            return ProgramShippingLocationDto.createFrom(
              value,
              new ProgramId(this.selectedProgramId)
            );
          });

          let filteredDeliveryLocationLookup = data.filter(
            (value, index, source) => {
              let idx = this.programDeliveryInformationDto.programShippingLocation.findIndex(
                programShippingLocation => {
                  return programShippingLocation.id == value.id;
                }
              );

              return idx == -1;
            }
          );

          this.itemObjectsRight = [];
          this.itemObjectsLeft = [...filteredDeliveryLocationLookup];
          this.itemObjectsLeft.filter(lft => lft.selected).forEach(address => {
            this.itemObjectsRight.push(address);
          });
          this.ready = true;
        } else {
          this.validationMessages = new ValidationMessage(
            res.error,
            true,
            "Delivery locations could not be retrieved"
          );
        }
      },
      (err: any) => {
        this.validationMessages = new ValidationMessage(
          null,
          true,
          "Unexpected error occured"
        );
      },
      () => { }
    );
  }

  getObjectsLeft() {
    if (this.addressFilter) {
      return this.itemObjectsLeft.filter(a =>
        a.location.toLocaleLowerCase().indexOf(this.addressFilter.toLocaleLowerCase()) > -1 &&
        !this.itemObjectsRight.find(b => b.deliveryLocationId == a.deliveryLocationId)
      )
    }
    return this.itemObjectsLeft.filter(a =>
      !this.itemObjectsRight.find(b => b.deliveryLocationId == a.deliveryLocationId)
    )
  }

  selectAddress(address: ProgramShippingLocationDto) {
    if (Boolean(this.itemObjectsRight.length) && this.disableAddressSelection) {
      return;
    }
    if (!this.itemObjectsRight.find(a => a.deliveryLocationId == address.deliveryLocationId)) {
      this.programService.AddRemoveShippingLocation({
        add: 1,
        programid: this.selectedProgramId,
        shippingLocationId: address.deliveryLocationId
      }).subscribe(() => {
        this.itemObjectsRight.push(address);
      });
    }
  }

  unSelectAddress(address: ProgramShippingLocationDto) {
    this.programService.AddRemoveShippingLocation({
      delete: 1,
      programid: this.selectedProgramId,
      shippingLocationId: address.deliveryLocationId
    }).subscribe(() => {
      this.itemObjectsRight = this.itemObjectsRight.filter(a => a.deliveryLocationId != address.deliveryLocationId);
    });
    // this.saveDeliveryInformation();
  }

  getDistribution() {
    this.programService.getDistributionLocation(this.selectedProgramId, this.searchTerm).subscribe(response => {
      this.distributionDto = response.data;
    });
  }

  isDistributable(tactic: Tactic) {
    return tactic.orderQuantity % tactic.locations.length === 0;
  }

  canDistributeEqually() {
    let allCanBeDistributed = true;
    this.distributionDto.tactics.forEach(tactic => {
      if (!this.isDistributable(tactic)) {
        allCanBeDistributed = false;
      }
    });

    return allCanBeDistributed;
  }

  distributeEqually() {
    if (!this.canDistributeEqually()) {
      this.validationMessages = new ValidationMessage(null, true, "One or more of your order quantities can not be distributed evenly.").isDanger();
      return;
    }

    this.distributionDto.tactics.forEach(tactic => {
      tactic.locations.forEach(location => {
        location.distributionQuantity = tactic.orderQuantity / tactic.locations.length;
      });
    });

    this.saveDistribution();
  }

  saveDistribution() {
    this.submitted = false;
    console.log(this.distributionDto.tactics);

    if (!this.canSubmitDistribution()) {
      this.submitted = true;
      // tslint:disable-next-line:max-line-length
      this.validationMessages = new ValidationMessage(null, true, "All tactics must be distributed for at least one location and the total distribution must equal order quantity").isDanger();
      return;
    }

    this.programService.saveShippingLocationDistribution(this.selectedProgramId, this.distributionDto.tactics).subscribe(data => {
      this.programService.deliveryLocationSaved.next();
      this.validationMessages = new ValidationMessage(null, true, "Distribution information saved").isSuccess();
    });
  }

  canSubmitDistribution() {
    let canSubmit = true;
    if (!this.distributionDto.tactics || this.distributionDto.tactics.length === 0) {
      return true;
    }
    this.distributionDto.tactics.forEach(t => {
      if (!this.validateDistribution(t)) {
        canSubmit = false;
      }
    });
    return canSubmit;
  }

  validateDistribution(t: Tactic) {
    let total = 0;
    t.locations.forEach(item => {
      if (item.distributionQuantity) {
        // tslint:disable-next-line:radix
        total += parseInt(item.distributionQuantity.toString());
      } else {
        total += 0;
      }
    });
    return total === t.orderQuantity;
  }

  downloadTemplate(): void {
    this.programService.getTemplate();
  }

  onStatesTypeaheadSelected($event: TypeaheadMatch): void {
    if ($event && $event.item.stateCode)
      this.shippingLocationDto.state = $event.item.stateCode;
  }

  onCountriesTypeaheadSelected($event: TypeaheadMatch): void {
    if ($event && $event.item.id)
      this.shippingLocationDto.country = $event.item.countryCode;
  }

  onStateSelected($event) {
    console.log('onStateSelected', $event);
    this.shippingLocationDto.state = $event;
  }

  onSubmitShipping(): Promise<void> {
    if (this.saving) {
      return;
    }
    this.saving = true;
    return new Promise((resolve, reject) => {
      this.submitted = false;

      if (!this.canSubmitShippingLocation()) {
        this.saving = false;
        this.submitted = true;
        this.validationMessages = new ValidationMessage(null, true, "there are some validation errors.");
        reject()
        return;
      }

      this.shippingLocationDto.programid = this.selectedProgramId;
      if (!this.fromCampaigns) {
        this.shippingLocationDto.deliveryDate = this.programDeliveryInformationDto.deliveryDate;
        this.shippingLocationDto.deliveryNotes = this.programDeliveryInformationDto.deliveryNotes;
      }
      
      let observe: Observable<ApiResponse<any>>;
      observe = this.programService.createProgramShippingLocation({
        ...this.shippingLocationDto,
        programid: this.shippingLocationDto.programid || 0
      });
      observe.subscribe(res => {
        if (!res.hasError) {
          if (!this.fromCampaigns) {
            this.validationMessages = new ValidationMessage(null, true, "New shipping location added").isSuccess();
            console.log('>>ShippingLocationSubmit', res.data);
            this.programService.deliveryLocationAdded.next(new ProgramId(this.selectedProgramId));
            this.programService.addressAdded.next(new ProgramId(this.selectedProgramId));
            this.loadProgram();
          } {
            resolve();
          }
          this.loadDeliveryLocationLookup();
          this.saving = false;
          this.shippingLocationDto = {} as ShippingLocationDto;
        } else {
          this.saving = false;
          this.validationMessages = new ValidationMessage(res.error, true, "shipping location not be saved");
          reject();
        }
      },
        (err: any) => {
          this.saving = false;
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
          reject();
        },
        () => {
        });
    })
  }

  close() {
    this.layoutService.hideSideModal.next();
  }

  isCountryValid() {
    return this.shippingLocationDto.country != null && this.shippingLocationDto.country !== undefined;
  }

  isStateValid() {
    console.log(this.shippingLocationDto.state)
    return this.shippingLocationDto.state != null && this.shippingLocationDto.state !== undefined;
  }

  canSubmitShippingLocation() {
    return this.isCountryValid() &&
      this.isStateValid() &&
      this.isFutureDate();
  }

  openManualDistribution() {
    this.saveDeliveryInformation().then((success) => {
      if (success) {
        this.router.navigateByUrl(`/tactic-catalog/${this.selectedProgramId}/finalize/distribution`)
      }
    });
  }

  private createPlanModalConfig = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "modal-lg"
  };
  openAddressEdit(location) {
    const initialState = { selectedId: location.deliveryLocationId }
    // tslint:disable-next-line:max-line-length
    this.createPlanModal = this.modalService.show(AddressEditModalComponent, Object.assign({}, this.createPlanModalConfig, { initialState }));
  }

  goToAddressBook() {
    this.type = "address_book";
  }

  openImportAddress() {
    this.type = "import-locations";
  }

  openCreateNewLocation() {
    this.type = "create-locations";
  }

  selectAll() {
    this.onSelectAllClicked.emit();
  }

  openAddressReviewList() {
    console.log('this.itemObjectsRight', this.itemObjectsRight)
    const initialState = { 
      addresses: this.itemObjectsRight
    }
    this.createPlanModal = this.modalService.show(AddressListModalComponent, Object.assign({}, this.createPlanModalConfig, { initialState }));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/delivery-information/delivery-information.component.ts